import { affiliateTrackingUrl } from '../constants/siteDomains';

/** Cookie compartilhado entre app.constelabrasil.com.br e constelabrasil.com.br */
export const INFLUENCER_REF_COOKIE = 'cb_influencer_ref';
export const INFLUENCER_REF_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
/** Destino após clique em /r/:code ou ?ref= (cookie .constelabrasil.com.br + localStorage). */
export const INFLUENCER_LANDING_URL = 'https://constelabrasil.com.br/constelador';

/**
 * Extrai o código de /r/:code mesmo quando o WhatsApp cola a URL duas vezes
 * (ex.: /r/codigohttps://app.constelabrasil.com.br/r/codigo).
 */
export function parseInfluencerCodeFromPathname(pathname: string): string | null {
  const match = (pathname || '').match(/^\/r\/(.+)/i);
  if (!match) return null;
  const beforeEmbeddedUrl = match[1].split(/https?:\/\//i)[0];
  const code = beforeEmbeddedUrl.split('/')[0].trim().toLowerCase();
  return code || null;
}

const LOCAL_STORAGE_AT_KEY = `${INFLUENCER_REF_COOKIE}_at`;

function isConstelaDomain(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.endsWith('constelabrasil.com.br');
}

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const prefix = `${name}=`;
  const part = document.cookie.split(';').find((c) => c.trim().startsWith(prefix));
  if (!part) return null;
  try {
    return decodeURIComponent(part.trim().slice(prefix.length));
  } catch {
    return null;
  }
}

function writeCookie(name: string, value: string, maxAgeSeconds: number): void {
  if (typeof document === 'undefined' || !isConstelaDomain()) return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; domain=.constelabrasil.com.br; path=/; max-age=${maxAgeSeconds}; SameSite=Lax${secure}`;
}

/** Last-click: sobrescreve o código anterior (janela de 30 dias). */
export function setInfluencerRef(code: string): void {
  const normalized = code.trim().toLowerCase();
  if (!normalized) return;

  const maxAgeSeconds = Math.floor(INFLUENCER_REF_MAX_AGE_MS / 1000);
  writeCookie(INFLUENCER_REF_COOKIE, normalized, maxAgeSeconds);

  try {
    localStorage.setItem(INFLUENCER_REF_COOKIE, normalized);
    localStorage.setItem(LOCAL_STORAGE_AT_KEY, String(Date.now()));
  } catch {
    // ignore quota / private mode
  }
}

export function getInfluencerRef(): string | null {
  const fromCookie = readCookie(INFLUENCER_REF_COOKIE);
  if (fromCookie) return fromCookie.trim().toLowerCase();

  try {
    const code = localStorage.getItem(INFLUENCER_REF_COOKIE);
    const atRaw = localStorage.getItem(LOCAL_STORAGE_AT_KEY);
    if (!code) return null;
    const at = atRaw ? Number(atRaw) : 0;
    if (at && Date.now() - at > INFLUENCER_REF_MAX_AGE_MS) {
      localStorage.removeItem(INFLUENCER_REF_COOKIE);
      localStorage.removeItem(LOCAL_STORAGE_AT_KEY);
      return null;
    }
    return code.trim().toLowerCase();
  } catch {
    return null;
  }
}

/** Lê ?ref= da URL e persiste (last-click). */
export function captureInfluencerRefFromSearch(search: string): void {
  const ref = new URLSearchParams(search).get('ref');
  if (ref) setInfluencerRef(ref);
}

export function buildInfluencerTrackingUrl(code: string): string {
  return affiliateTrackingUrl(code);
}
